<script>
	import {
		GovernmentSolution,
		HotelSolution,
		LargeProjectSolution,
		OfficeSolution,
	} from '$lib/data/solutions/solutions-data';
	const commercialSolutions = [
		LargeProjectSolution,
		HotelSolution,
		OfficeSolution,
		GovernmentSolution,
	];
</script>

<div
	class="
   col-[full-width]! w-full bg-indow-blue px-4 py-6
   md:col-[content]! md:rounded-xl
 "
>
	<h3 class="mb-3 text-2xl">Commercial Insulation</h3>
	<p>
		Indow inserts aren't just for your home. Our innovative solutions are ideal
		for large-scale commercial projects.
	</p>
	<ul
		class="
    grid list-none grid-cols-1 gap-4
    xs:grid-cols-2
    md:grid-cols-4
  "
	>
		{#each commercialSolutions as { title, src, href }, index (index)}
			<li
				class="
      m-0 overflow-hidden rounded-md transition-colors duration-200
      hover:bg-white/20
    "
			>
				<a {href}>
					<p class="mb-6 text-center">
						<span
							class="
         mb-3 block h-20 text-indow-white
         md:h-30
       "
						>
							{@render src()}
						</span>
						<span
							class="
         inline-block rounded-sm bg-indow-white p-3 px-4 font-bold
         text-indow-blue no-underline
       "
						>
							{title}
						</span>
					</p>
				</a>
			</li>
		{/each}
	</ul>
</div>
